var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMirWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 21,
    viewBox: "0 0 121 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15289_1781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 6.96545L53.467 20.1908H59.0683L60.3611 16.6H62.4382L58.9709 6.96545Z",
    fill: "#F2F3EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4886 20.1908H75.1542L66.9965 0.658325H62.4553L69.4886 20.1908Z",
    fill: "#F2F3EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.61792 0.500244V20.1587H5.78976V10.0432L10.4671 13.7865V7.58422L1.36105 0.500244H0.61792Z",
    fill: "#F2F3EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3622 0.5L13.321 7.5762V13.7742L17.9619 10.0148V20.1585H23.1337V0.5H22.3622Z",
    fill: "#F2F3EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.172 19.4567V14.7703C108.59 15.4878 110.287 16.0177 111.9 16.1558C112.456 16.2055 112.987 16.2055 113.488 16.1779C115.127 16.073 116.047 15.6479 116.047 14.8476C116.047 13.8375 114.793 13.3295 112.347 12.4463C108.979 11.2263 106.809 9.89054 106.809 6.37422C106.809 2.85789 109.843 0.561523 114.404 0.561523C116.407 0.561523 118.412 0.936931 119.746 1.47239V5.9768C118.551 5.25359 116.657 4.77335 114.822 4.77335C112.987 4.77335 111.817 5.38613 111.817 6.34661C111.817 7.25188 112.987 7.86465 115.323 8.76992C118.689 10.0506 121 11.4085 121 14.82C121 18.3638 118.216 20.5001 113.237 20.5001C110.955 20.5 108.673 20.0695 107.172 19.4567Z",
    fill: "#F2F3EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9006 0.823975H26.7014V20.1841H31.9006V0.823975Z",
    fill: "#F2F3EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.537 0.823975H98.3376V20.1841H103.537V0.823975Z",
    fill: "#F2F3EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8542 17.1436L48.568 12.2851C48.9128 12.2277 49.2573 12.1701 49.6022 12.0553C51.9001 11.3658 53.7385 9.61355 53.7385 6.68363C53.7385 2.97823 50.7798 0.823975 46.4424 0.823975H35.4697V20.1841H40.6689V13.3764V12.9169V9.15409V7.63187V4.70195H45.7531C47.534 4.70195 48.4244 5.64981 48.4244 6.82746C48.4244 8.29227 47.4765 9.15409 45.6668 9.15409H43.4429V12.9929L47.735 20.1842H50.6028L51.8542 17.1436Z",
    fill: "#F2F3EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6111 5.03267L81.7369 0.823975H75.3027L82.2825 10.418L76.9963 17.724L78.0263 20.1841H81.5358L84.5214 16.0365L84.6111 5.03267Z",
    fill: "#F2F3EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4637 10.418L96.4723 0.824097H90.1244L87.2034 5.02663L87.2037 16.055L90.0668 20.1842H96.5011L89.4637 10.418Z",
    fill: "#F2F3EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4885 20.1928L62.4554 0.660522L61.5609 0.671243L60.4917 3.30298L66.8536 20.1928H69.4885Z",
    fill: "#D4E79E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15289_1781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120.382,
    height: 20,
    fill: "white",
    transform: "translate(0.618164 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirWhiteLogo);
export default __webpack_public_path__ + "static/media/mir_white_logo.7b5defa11f949f3ddc881be5a9a3c028.svg";
export { ForwardRef as ReactComponent };